import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

const valid_elements = [
    'a[href|target=_blank]',
    'strong/b',
    'div[align]',
    'br',
    'p',
    'ul',
    'li',
].join(',');

const defaultConfig = {
    base_url: '/tinymce',
    suffix: '.min',
    branding: false,
    menubar: false,
    plugins: ['advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'],
    toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
    inline: false,
    valid_elements,
    height: 250,
};

@Component({
    selector: 'ngx-formly-multilang-question-answer',
    templateUrl: './formly-multilang-question-answer.component.html',
    styleUrls: ['./formly-multilang-question-answer.component.scss']
})
export class FormlyMultilangQuestionAnswerComponent extends FieldType implements OnInit {

    activeTab: string;
    tabs: any = [];
    editorConfig = {
        ...defaultConfig
    };

    ngOnInit(): void {
        this.tabs = this.to.languages.map((lang: string) => {
            return {
                lang: lang,
                title: lang.toUpperCase(),
                active: true
            }
        });
        this.tabs[0].active = true;
    }

}
